import handleUntilEventStarts from './ticketOnSaleConditions/handleUntilEventStarts';
import handleDateTimeBased from './ticketOnSaleConditions/handleDateTimeBased';
import handleAfterTicketSalesEnd from './ticketOnSaleConditions/handleAfterTicketSaleEnds';
import handleAfterTicketSellsOut from './ticketOnSaleConditions/handleAfterTicketSellsOut';
import handleAfterTicketSaleEndsOrSellsOut from './ticketOnSaleConditions/handleAfterTicketSaleEndsOrSellsOut';
import checkIsTicketTypeSoldOut from '@repo/checkout/lib/checkIsTicketTypeSoldOut';

export default function checkIsTicketTypeOnSale({ ticketType, allTicketTypes = [], page }) {
  if (
    !ticketType ||
    ticketType.status !== 'enabled' ||
    ticketType.availabilityStatus !== 'available'
  )
    return false;

  const availabilityBehavior = ticketType.availabilityBehavior || 'always_available';
  const now = new Date();
  const entityKey = 'triggerTicketType';

  switch (availabilityBehavior) {
    case 'always_available': {
      return true;
    }
    case 'until_event_starts': {
      return handleUntilEventStarts({ page, now });
    }
    case 'date_time_based': {
      return handleDateTimeBased({ entity: ticketType, now });
    }
    case 'after_ticket_sale_ends': {
      return handleAfterTicketSalesEnd({
        entity: ticketType,
        allEntities: allTicketTypes,
        entityKey,
        now,
      });
    }
    case 'after_ticket_sold_out': {
      return handleAfterTicketSellsOut({
        entity: ticketType,
        allEntities: allTicketTypes,
        now,
        entityKey,
        checkSoldOutFunc: checkIsTicketTypeSoldOut,
      });
    }
    case 'after_ticket_ends_or_sold_out': {
      return handleAfterTicketSaleEndsOrSellsOut({
        entity: ticketType,
        allEntities: allTicketTypes,
        now,
        entityKey,
        checkSoldOutFunc: checkIsTicketTypeSoldOut,
      });
    }
    default:
      return true;
  }
}
